export default __webpack_public_path__ + "static/media/icon_place.4ab33fee.svg";